import Team from "./Team";
import React from "react";

function ListTeams(props: { teams: any, loadData: any }) {
  const {teams, loadData} = props;

  const teamComponents = teams.map((team: any) =>
    <Team team={team} key={team.id} loadData={loadData}/>
  )

  return (
    <div className="row px-2">
      <ul className="list-group list-group-horizontal list-group-flush d-flex flex-wrap justify-content-between justify-content-md-start">
      {teamComponents}
      </ul>
    </div>
  );
}

export default ListTeams;
